import React from 'react';
import KickImage from 'Reuseables/KickImage';
import propTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import classNames from "classnames";

import { getCacheImage } from '../../../config'
import withVerifiedUser from "../../hoc/withVerifiedUser"

const HandleRedirect = (props) => {
  return window.open(props, '_newtab');
}

const KickLink = ({ href, altText, children, onClick, category }) => {
  return href.includes('.') ? (
    <a href={href} onClick={onClick} title={altText} className={classNames("full progressive replace", { "luxury": category === "handbags" })}>
      {children}
    </a>
  ) : (
      <Link to={href} onClick={onClick} title={altText} className={classNames("full progressive replace", { "luxury": category === "handbags" })}>
        {children}
      </Link>
    )
}

const KickLinkNew = ({ href, altText, children, onClick, category }) => {
  return (
    <div onClick={onClick} title={altText} className="full progressive replace" style={{ cursor: "pointer" }}>
      {children}
    </div>
  )
}

const KickLinkAuthUser = withVerifiedUser(KickLinkNew)

const KickCarouselItemContent = (props) => {
  const { src, altText, isLink, href, pageType, dataAuth, history, id, dataCategory } = props;
  //use this to test
  // const url = "sneakers/raffle-preview"
  const isRewards = href && href.includes("user_dashboard/rewards");

  if (isLink) {
    if (pageType === "PREVIEW_RAFFLE_SCREEN" || pageType === "RAFFLE_DETAIL_SCREEN" || isRewards) {
      return (
        <KickLinkAuthUser
          href={href}
          altText={altText}
          onClick={(e) => { e.preventDefault(); HandleRedirect(href) }}
          isLogged={dataAuth.isLogged}
          userData={dataAuth.userdata}
          roleNotAlloweds={['unverified_user']}
          redirectTo={href}
          isCarousel
          history={history}
          category={dataCategory}
        >
          <KickImage
            className={classNames("preview", { "luxury": dataCategory === "handbags" })}
            alt={altText}
            src={getCacheImage(src)} />
        </KickLinkAuthUser>
      )
    } else {
      return (
        <KickLink
          href={href}
          altText={altText}
          onClick={(e) => { e.preventDefault(); HandleRedirect(href); props.onSliderClick(id); }}
          category={dataCategory}
        >
          <KickImage className={classNames("preview", { "luxury": dataCategory === "handbags" })} alt={altText} src={getCacheImage(src)} />
        </KickLink>
      )
    }
  } else return <KickImage alt={altText} src={getCacheImage(src)} />
}

const mapStateToProps = (state) => ({
  dataCategory: state.dataCategory.selected
})


export default connect(mapStateToProps, null)(KickCarouselItemContent);

KickCarouselItemContent.propTypes = {
  href: propTypes.string,
  altText: propTypes.string,
  isLink: propTypes.bool,
  src: propTypes.string.isRequired
}

KickCarouselItemContent.defaultProps = {
  isLink: false
}
